import { render } from "./TrainingDialog.vue?vue&type=template&id=28b363bc&scoped=true&ts=true"
import script from "./TrainingDialog.vue?vue&type=script&lang=ts"
export * from "./TrainingDialog.vue?vue&type=script&lang=ts"

import "./dialog.scss?vue&type=style&index=0&id=28b363bc&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28b363bc"]])

export default __exports__